export enum RequestHistoryGetActionTypes {
  request = 'apiKey/GET_REQUEST_HISTORY/REQUEST',
  success = 'apiKey/GET_REQUEST_HISTORY/SUCCESS',
  failure = 'apiKey/GET_REQUEST_HISTORY/FAILURE',
  cancel = 'apiKey/GET_REQUEST_HISTORY/CANCEL',
}
